import { render, staticRenderFns } from "./KWInput.vue?vue&type=template&id=b4651a06&scoped=true&"
import script from "./KWInput.vue?vue&type=script&lang=js&"
export * from "./KWInput.vue?vue&type=script&lang=js&"
import style0 from "./KWInput.vue?vue&type=style&index=0&id=b4651a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4651a06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VTextField})
